import { Fragment } from 'react';
import { Box, Link, Typography } from '@mui/material';
import SectionFileRow from './SectionFileRow';
import NoteBox from './NoteBox';
import {
  INFO_GRID_LABEL_SX,
  INFO_GRID_SX,
  INFO_GRID_VALUE_SX,
} from './sidebarInfoGrid';

export interface ServiceDetailGridField {
  label: string;
  value: string;
  url?: string;
}

export interface ServiceDetailNoteField {
  label: string;
  text: string;
}

export interface ServiceDetailPhotoRow {
  label: string;
  urls: string[];
}

interface Props {
  gridFields: ServiceDetailGridField[];
  noteFields: ServiceDetailNoteField[];
  photoRows: ServiceDetailPhotoRow[];
}

function ServiceDetailBody({ gridFields, noteFields, photoRows }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        width: '100%',
      }}>
      {!!gridFields.length && (
        <Box sx={INFO_GRID_SX}>
          {gridFields.map(field => (
            <Fragment key={field.label}>
              <Typography component="span" sx={INFO_GRID_LABEL_SX}>
                {field.label}
              </Typography>
              {field.url ? (
                <Link
                  href={field.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    ...INFO_GRID_VALUE_SX,
                    color: 'var(--sidebar-brand)',
                    fontWeight: 500,
                  }}>
                  {field.value}
                </Link>
              ) : (
                <Typography component="span" sx={INFO_GRID_VALUE_SX}>
                  {field.value}
                </Typography>
              )}
            </Fragment>
          ))}
        </Box>
      )}

      {noteFields.map(note => (
        <NoteBox key={note.label} label={note.label} text={note.text} />
      ))}

      {photoRows.map(row => (
        <SectionFileRow
          key={row.label}
          label={row.label}
          values={row.urls.map(url => ({
            id: url,
            url,
            name: 'url',
            type: 'image',
          }))}
          compact
        />
      ))}
    </Box>
  );
}

export default ServiceDetailBody;
